import { createRoot } from 'react-dom/client'
import { LazyMotion, domAnimation } from 'framer-motion'
import './styles.css'
import App from './App'
import { initPosthogWhenIdle } from './lib/posthogClient'

// LazyMotion + the `m` component instead of `motion`: `motion.div` statically
// pulls in every feature framer-motion has, because the component itself is the
// entry point. `m` ships only the renderer, and `domAnimation` adds animations,
// variants and tap/hover gestures — everything this site actually uses. Drag and
// layout animations (the `domMax` half) are not used, so they are not shipped.
//
// `strict` makes this enforceable: it throws if a `motion.*` component sneaks
// back in, which would silently restore the full bundle.
const app = (
  <LazyMotion features={domAnimation} strict>
    <App />
  </LazyMotion>
)

const container = document.getElementById('root')
createRoot(container).render(app)

// Analytics loads as its own chunk once the page is idle. No component reads
// PostHog's React context, so there is no Provider here — autocapture works off
// the global instance, and the Provider only served to pull 142KB into the
// critical bundle.
initPosthogWhenIdle()
